module.exports = __webpack_public_path__ + "img/buton_policy.8e581281.png";